import styled from 'styled-components';
import { Text } from '@lmn/design-system';
import { useRoomAvailabilityAlertLabel } from '@/app/components/hotel-detail/hooks/useRoomAvailabilityAlertLabel';

const AlertPill = styled.div`
  display: inline-flex;
  align-items: center;
  padding: ${({ theme }) => theme.kallisto.space.space50} ${({ theme }) => theme.kallisto.space.space100};
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundWarningSubtle};
  border-radius: ${({ theme }) => theme.kallisto.border.radius.radius50};
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderWarningSubtle};
`;

export function EvoRoomAvailabilityAlertLabel({
  roomsLeft,
  ...rest
}: { roomsLeft: number } & React.HTMLAttributes<HTMLDivElement>) {
  const { show, label } = useRoomAvailabilityAlertLabel(roomsLeft);

  if (!show) return null;

  return (
    <AlertPill {...rest}>
      <Text variant="BodySmall" color="textWarning">
        {label}
      </Text>
    </AlertPill>
  );
}
